import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './store';
import App from './App';
import './index.css';
import websocketService from './services/websocketService';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ThemeProvider } from './components/theme/ThemeProvider';
import config from './config';
import { AuthBootstrap } from './components/AuthBootstrap';

// Initialize websocket service with the Redux store
websocketService.initialize(store);

const driveApiBaseUrl =
  process.env.REACT_APP_DRIVE_API_URL ||
  config.server.driveApiUrl ||
  'https://api.drive.cynayd.com';

const router = createBrowserRouter(
  [
    {
      path: '*',
      element: (
        <AuthBootstrap apiBaseUrl={driveApiBaseUrl}>
          <App />
        </AuthBootstrap>
      )
    }
  ],
  {
    future: config.router?.future || {
      v7_startTransition: true,
      v7_relativeSplatPath: true
    }
  }
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider>
        <RouterProvider router={router} />
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);
